exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!./slim.min.css"), "");

// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /~/css-loader!/~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1e8c4e74","scoped":false,"hasInlineConfig":false}!/~/vue-loader/lib/selector.js?type=styles&index=0!./assets/js/vue/vendor/slim/slim.vue
// module id = 390
// module chunks = 0